import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostInvitationAccept = () => {
  return useMutation({
    mutationFn: authService.postInvitationAccept,
    throwOnError: false,
  });
};
